import React from 'react';
import UIPage, { UIPageBody } from '@/components/ui/page';
import { jsx as _jsx } from "react/jsx-runtime";

var PageLayout = function PageLayout(_ref) {
  var children = _ref.children,
      variant = _ref.variant;
  return /*#__PURE__*/_jsx(UIPage, {
    children: variant === 'enterprise' && /*#__PURE__*/_jsx(UIPageBody, {
      children: children
    })
  });
};

export default PageLayout;